import { createActionGroup, emptyProps } from '@ngrx/store';

export const SocieteActions = createActionGroup({
  source: 'Societe',
  events: {
    'Clear State On Societe Change': emptyProps()
  }
});
